import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QUERY_KEYS } from '~constants'
import { getServerUser, writeToStorageCacheQuery } from '~services'
import { UserResponse } from '~types/user'

const { USER } = QUERY_KEYS

const userQueryKey = [USER] as [string]

export const useGetUser = (options?: UseQueryOptions<UserResponse, unknown, UserResponse>) => {
  const {
    data: user,
    isLoading: isLoadingUser,
    isFetching: isFetchingUser,
    refetch: refetchUser,
    status: userStatus,
  } = useQuery<UserResponse>(userQueryKey, getServerUser, {
    onSuccess: (data) => {
      writeToStorageCacheQuery(userQueryKey, data)
    },
    ...options,
  })

  return { refetchUser, user: user?.user, userStatus, isLoadingUser, isFetchingUser }
}
